import {InfoIcon} from '@chakra-ui/icons';
import {HStack, Text, VStack} from '@chakra-ui/layout';
import {Badge} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {useHalState} from '@synako/haligator';
import {useClient} from '@/haligator-factory';

/**
 * Encart affichant le motif de blocage Tolede du client dans le récapitulatif du panier,
 * au-dessus du bouton de validation.
 *
 * L'encart s'affiche si l'utilisateur expose la ressource statut_tolede,
 * que le back ne donne qu'avec la permission voir-statut-financier,
 * et seulement quand peut_commander vaut bloque
 */
export const PanierRecapStatutTolede: React.FC = () => {
  const {t} = useTranslation();
  const statutTolede = useHalState(useClient().follow('statut_tolede'));

  if (statutTolede.data?.tolede.peut_commander !== 'bloque') return null;

  return (
    <VStack
      gap='2'
      order={{base: '-1', lg: 'initial'}} // Avant le bouton "Valider"
      alignItems='stretch'
      border='1px solid'
      borderColor='gray.light'
      borderRadius='8px'
      p='3'
    >
      <Text fontSize='sm'>{t('panier.recap.statut_tolede')}</Text>
      <Badge
        bg='gray.dark_transparency_10'
        color='gray.dark'
        borderRadius='8px'
        px='6px'
        py='4px'
        textTransform='none'
        fontSize='12px'
        fontWeight='500'
      >
        {statutTolede.data.tolede.motif_de_blocage
          ? t(`motif_de_blocage.${statutTolede.data.tolede.motif_de_blocage}`)
          : t('panier.recap.motif_blocage_non_precise')}
      </Badge>
      <HStack
        bg='orange.warning_50'
        textColor='orange.warning'
        borderRadius='8px'
        px='3'
        py='2'
        gap='2'
      >
        <InfoIcon />
        <Text fontSize='xs'>{t('panier.recap.commande_impossible')}</Text>
      </HStack>
    </VStack>
  );
};
